import React, { useState } from "react";
import { Container, Button } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { FaExclamationCircle } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import apiClient from "../Login/apiClient";

const StyledContainer = styled(Container)`
  min-height: 70vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 24px 16px;
  text-align: center;
`;

const Spacer = styled.div`
  height: 12px;
`;

const ButtonStack = styled.div`
  width: min(100%, 320px);
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`;

const StyledButton = styled(Button)`
  width: 100%;
  min-height: 52px;
  font-size: 1rem;
  font-weight: 700;
  white-space: normal;
  word-break: keep-all;
  border-radius: 14px;
`;

const SecondaryStyledButton = styled(Button)`
  width: 100%;
  min-height: 52px;
  font-size: 1rem;
  font-weight: 700;
  background-color: #1f2937;
  color: #ffffff;
  border-color: #1f2937;
  white-space: normal;
  word-break: keep-all;
  border-radius: 14px;

  &:hover,
  &:focus,
  &:active {
    background-color: #111827;
    color: #ffffff;
    border-color: #111827;
  }
`;

const StyledLink = styled(Link)`
  width: 100%;
  color: inherit;
  text-decoration: none;

  &:hover {
    color: inherit;
    text-decoration: none;
  }
`;

const StyledCheckMark = styled(FaExclamationCircle)`
  color: #111827;
  font-size: 70px;
  margin: 8px 0 16px;
`;

function DeleteGoal() {
  const location = useLocation();
  const navigate = useNavigate();
  const goalId = location.state?.goalId;
  const [deleting, setDeleting] = useState(false);

  const handleDeleteGoal = async () => {
    if (deleting) return;
    if (!goalId) {
      toast.error("削除する夢が見つかりません。");
      return;
    }

    setDeleting(true);
    try {
      await apiClient.delete(`/api/goals/${goalId}/`);
      toast.success("夢を削除しました。");
      setTimeout(() => navigate("/"), 1200);
    } catch (error) {
      const errorCode = error?.response?.status;
      if (errorCode === 403) {
        toast.error("この夢を削除する権限がありません。");
      } else if (errorCode === 404) {
        toast.error("夢が見つかりません。すでに削除されているかもしれません。");
      } else if (errorCode === 401) {
        toast.error("ログイン状態を確認してから、もう一度試してください。");
      } else if (errorCode === 500) {
        toast.error("削除に失敗しました。少し時間をおいてもう一度試してください。");
      } else {
        toast.error("予期せぬエラーが発生しました。");
      }
      setDeleting(false);
    }
  };

  return (
    <StyledContainer>
      <h2>本当にこの夢をあきらめますか？</h2>
      <StyledCheckMark />
      <h4>
        この操作をすると、トップページに戻ります。
        <br />
        取り消したい場合は、夢を投稿し直してください。
      </h4>
      <Spacer />
      <ButtonStack>
        <StyledButton variant="danger" onClick={handleDeleteGoal} disabled={deleting}>
          {deleting ? "削除中..." : "夢をあきらめる"}
        </StyledButton>
        <StyledLink to="/">
          <SecondaryStyledButton type="button">トップページに戻る</SecondaryStyledButton>
        </StyledLink>
      </ButtonStack>
      <ToastContainer position="top-center" autoClose={3000} />
    </StyledContainer>
  );
}

export default DeleteGoal;
